module.exports = __webpack_public_path__ + "static/media/Xeirokrotima_7.37ca8ef5.jpg";